<template>
    <div>
        <!-- Left Side Information -->
        <table class="table table-bordered" border="0" width="60%" style="padding: 0; margin: 0; float: left">
            <tr>
                <td align="left" style="padding: 0; margin: 0;"
                    :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                >
                    <img :src="getCompanyLogo" style="height: 100px"/>
                    <span v-if="getCompanyName"><br>{{getCompanyName}}</span>
                    <span><br>NIF: {{getNif}}</span>
                    <span><br>{{getLocation}}</span>
                    <span v-if="getCompanyPhone"><br>Tel: {{getCompanyPhone}}</span>
                    <span v-if="getCompanyEmail"><br>Email: {{getCompanyEmail}}</span>
                    <!--<span style="font-size: 13px"><br>{{getNib}}</span><br>-->
                    <span :style="[isInvoiceA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]" v-if="getPrimaryNib"><br>{{getPrimaryNib}}</span>
                    <span :style="[isInvoiceA5Format ? {'font-size': '10px'} : {'font-size':'12px'}]" v-if="getSecondNib"><br>{{getSecondNib}}</span>
                </td>

            </tr>
        </table>
        
        <!-- Right Side Information -->
        <table class="table table-bordered" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" border="0" width="31%" style="padding: 0; margin: 0; margin-top: 50px; float: right">
            <tr >
                <td align="right" style="padding: 0; margin: 0;"
                    :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'12px'}]"
                >
                    <span v-if="selectedInvoice.code" style="font-weight: bold"
                            :style="[isInvoiceA5Format ? {'font-size': '11px'} : {'font-size':'14px'}]"
                    >{{getDocumentName}} nº {{getInvoiceCode()}}</span>
                    <br><br>
                    <span>Exmo(a). Senhor(a)<br></span>
                    <span><b>{{getClientName()}}</b></span>
                    <span v-if="getClientNif()"><br>NIF: {{getClientNif()}}</span>
                    <span v-if="getClientPhone()"><br>Tel: {{getClientPhone()}}</span> <span v-else><br></span>
                    <span v-if="getClientEmail()"><br>Email: {{getClientEmail()}}</span> <span v-else><br></span>
                </td>

            </tr>
        </table>
        <table width="100%" border="0" :class="isInvoiceA5Format ? 'a5format' : 'a4format'" style="padding: 0; margin-right: -10px; margin-bottom: -5px; float: right">
            <tr align="right">
                <td align="right" >
                    <h4 v-if="selectedInvoice.code">{{invoicePrintLabel}}</h4>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import { Types } from "../../../config";
    export default {
        created () {
            
        },

        data(){
            return {
                Types
            }
        },

        watch: {
            
        },

        props: {
            fetchedInvoice: {
               type: Object,
               default: () => ({}),
            },
            isInvoiceA5Format: {
                type: Boolean,
                default: false,
            },
            isInvoiceCanceled: {
                type: Boolean,
                default: false,
            },
            invoicePrintLabel: {
                type: String,
                default: "",
            },
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),

            getCompanyLogo(){
                let res = '';
                try{
                    res = this.loggedUser.group.company.image_path;
                }catch (e) { /*Do nothing*/}

                return res;
            },
            getCompanyName(){
                try{
                    return this.fetchedInvoice.sell.company.name;
                }catch (e) { return ""; }
            },
            getNif(){
                let res = '';
                try{
                    res = this.fetchedInvoice.sell.company.nif;
                }catch (e) {/*Do nothing*/}

                return res;
            },
            getLocation(){
                let res = '';
                try{
                    res = 'Endereço: '+this.fetchedInvoice.sell.company.address+', '+this.fetchedInvoice.sell.company.city.name;
                }catch (e) { /*Do nothing*/}

                return res;
            },
            getCompanyPhone(){
                // this.consoleLog('this.fetchedInvoice.sell');
                // this.consoleLog(this.fetchedInvoice.sell);
                return this.getPhone(JSON.parse(this.fetchedInvoice.sell.company.contacts_json));
            },

            getCompanyEmail(){
                try{
                    let json = JSON.parse(this.fetchedInvoice.sell.company.contacts_json);
                    return json[0].email;
                }catch (e) { return ""; }
            },
            getPrimaryNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedInvoice.sell.company.nib_bi; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedInvoice.sell.company.nib_bi_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { this.consoleLog(e); }
            },
            getSecondNib(){
                let nib = '', nib_name = '';
                try{
                    try { nib = this.fetchedInvoice.sell.company.nib_bi2; }catch (e) { /*Do nothing*/ }
                    try { nib_name = this.fetchedInvoice.sell.company.nib_bi2_name; }catch (e) { /*Do nothing*/ }
                    return this.getNibFormated(nib, nib_name);
                }catch (e) { return ''; }
            },



            getDocumentName(){
                switch (this.selectedInvoice.types_document_id) {
                    case Types.document_type.FACTURA:
                        return "Fatura";
                    case Types.document_type.FACTURA_RECIBO:
                        return "Fatura/Recibo";
                    default:
                        return "";
                }
            },
            selectedInvoice: {
                get(){ return this.$store.getters.getSelectedInvoice; },
                set(value){ this.$store.dispatch('setSelectedInvoice', value); }
            },

        },

        methods: {
            getClientName(){
                try{
                    // this.consoleLog('client: '+this.fetchedInvoice.sell.client.name);
                    return this.fetchedInvoice.sell.client.name;
                }catch (e) { console.log(e);return "";}
            },

            getClientNif(){
                try {
                    // this.consoleLog('nif: '+this.fetchedInvoice.sell.client.nif);
                    return this.fetchedInvoice.sell.client.nif;
                }catch (e) { return 'indefinido'; }
            },

            getClientPhone(){
                return this.getPhone(JSON.parse(this.fetchedInvoice.sell.client.contacts_json));
            },

            getClientEmail(){
                try{
                    let json = JSON.parse(this.fetchedInvoice.sell.client.contacts_json);
                    return json[0].email;
                }catch (e) { return ""}
            },
            getInvoiceCode(){
                return this.selectedInvoice.code + '/' + this.selectedInvoice.series;
            },

            getPhone(json){
                let mobile_phone = '', phone = '';
                try{
                    mobile_phone = json[0].mobile_phone;
                    phone = json[0].phone;

                    if(phone === null) phone = '';
                    if(mobile_phone === null) mobile_phone = '';
                }catch (e) {return ""}

                if(mobile_phone && phone)
                    return phone+" / "+mobile_phone;
                else if(!mobile_phone && !phone)
                    return '';
                else
                    return phone+""+mobile_phone;

            },
                        
            getNibFormated(nib, nib_name){
                let nibRes = '';
                nibRes = nib_name ? "Nib_"+nib_name+": " : "Nib: ";

                return nib ? nibRes += nib : '';
            },
        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }


</style>